import React, { useCallback, useState } from "react";
import { Container, Grid, Stack } from "@mui/material";
import SalaryPaymentForm from "../components/SalaryPaymentForm";
import SalaryPaymentList from "../components/SalaryPaymentList";
import FinancePageHeader from "../components/finance/FinancePageHeader";
import DashboardLayout from "../components/Layout/DashboardLayout";
import { useAuth } from "../context/AuthContext";

const SalaryPaymentsPage = () => {
  const { user } = useAuth();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreated = useCallback(() => {
    setRefreshKey((previousKey) => previousKey + 1);
  }, []);

  return (
    <DashboardLayout
      role={user?.role}
      activePage="/salary-payments"
      title="Paiements des salaires"
    >
      <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
        <Stack spacing={2.5}>
          <FinancePageHeader
            title="Paiements des salaires"
            subtitle="Enregistrez les paiements des agents et consultez l’historique par période."
          />

          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} lg={5}>
              <SalaryPaymentForm onCreated={handleCreated} />
            </Grid>

            <Grid item xs={12} lg={7}>
              <SalaryPaymentList refreshKey={refreshKey} />
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </DashboardLayout>
  );
};

export default SalaryPaymentsPage;